import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import facebookLogin from 'facebook-login';

// import Push from 'appcenter-push';
// import AppCenter from 'appcenter';

import screenActions from '../actions/screen'
import { connect } from "react-redux"
import utils from '../utils';
import constants from '../constants'

// test appcenter-push 
// async function enablePush() {
//   const pushEnabled = await Push.isEnabled();
//   const installId = await AppCenter.getInstallId();
//   console.warn("push ", pushEnabled);
//   console.warn("in id", installId);
//  // Push.setListener();
// }
// enablePush();

const FBApi = facebookLogin({ appId: utils.facebookAppId.toString() });

class Login extends Component {

  FBLogin(event) {
    if (window.cordova)
      this.FBMobileLogin();
    else
      this.FBWebLogin();
  }

  FBMobileLogin() {
    window['CordovaFacebook'].login({
      permissions: ['email', 'user_likes'],
      onSuccess: function (result) {
        if (result.declined.length > 0) {
          console.log("The User declined something!", result);
          return;
        }

        this.skip();
      },
      onFailure: function (result) {
        if (result.cancelled) {
          console.log("The user doesn't like my app", result);
        } else if (result.error) {
          console.log("There was an error:", result.errorLocalized, result);
        }
      }
    });
  }

  FBWebLogin() {
    FBApi.login()
      .then((response) => {
        // console.log(response)
        if (response.status === "connected") {
          this.skip()
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  skip(event) {
    if (event)
      event.preventDefault();

    this.props.history.push("/screen/" + constants.DEFAULT_SCREEN_ID);
    this.props.dispatch(screenActions.forceUpdate());
  }



  render() {

    // const { navigate } = this.props.navigation;
    return (
      <div className="flex-container">
        <div id="login">
          <a href="#facebook-login" className="fb-login" //TouchableOpacity
            onClick={this.FBLogin.bind(this)}
          >Facebook Login</a>

          <a href="#skip" className="subtle skip" onClick={this.skip.bind(this)}>skip</a>

        </div>
      </div>
    );
  }
}

export default withRouter(connect()(Login));